import { Outlet, useParams } from "react-router-dom";
import { NegotiationChat } from "../../components/chat/NegotiationChat";

export function NegotiationWithChat() {
  const { id } = useParams();
  
  if (!id) {
    return <h1>Please select a negotiation from the list.</h1>;
  }

  return (
    <>
      <Outlet />
      <NegotiationChat />
    </>
  );
}